/* Sidney Sleep — cart add-on checkboxes (Priority Processing / Shipping Protection)
 *
 * WHY THIS IS AN ASSET AND NOT INLINE IN THE SNIPPET:
 * On every page except /cart the theme builds the drawer with
 *   fetchSection() -> div.innerHTML = html -> container.appendChild(div)
 * (app.js:839 and :3831). A <script> inserted through innerHTML has its
 * "already started" flag set and NEVER executes, so an inline handler in the
 * drawer markup is dead everywhere the drawer is used — which is the main cart
 * UI. The same applies to renderNewCart(), which re-renders .scd__summary the
 * same way. So the handler must load once, from the page itself, and work by
 * delegation off document.
 *
 * Config comes from window.CART_ADDON_CONFIG, emitted by snippets/custom-code-body.liquid.
 */
(function () {
  if (window.__cartAddonsBound) return;
  window.__cartAddonsBound = true;

  var CFG = window.CART_ADDON_CONFIG || {};
  var ADDON_IDS = (CFG.ids || []).map(String);
  if (!ADDON_IDS.length) return;

  var busy = false;
  var cleaning = false;

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) throw new Error(url + ' responded ' + res.status);
      return res.json();
    });
  }

  function repaint() {
    var Cart = window.MinimogTheme && window.MinimogTheme.Cart;
    if (!Cart || typeof Cart.renderNewCart !== 'function') return Promise.resolve(false);
    return Cart.renderNewCart().then(function () {
      if (window.Shopify && typeof window.Shopify.onCartUpdate === 'function') {
        return window.Shopify.onCartUpdate(null, false);
      }
    }).then(function () { return true; });
  }

  /* An add-on stranded alone in the cart is not cosmetic: the checkboxes are
     hidden on an add-ons-only cart, so the customer cannot untick it and could
     check out paying for protection on nothing. Hiding the UI is not enough. */
  function clearStranded(cart) {
    if (cleaning) return Promise.resolve();

    var decide = cart
      ? Promise.resolve(cart)
      : fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; });

    return decide.then(function (c) {
      if (!c || !c.items) return;
      var hasAddon = false, hasReal = false;
      c.items.forEach(function (i) {
        if (ADDON_IDS.indexOf(String(i.variant_id)) !== -1) hasAddon = true;
        else hasReal = true;
      });
      if (!hasAddon || hasReal) return;

      cleaning = true;
      var updates = {};
      ADDON_IDS.forEach(function (id) { updates[id] = 0; });
      return postJSON('/cart/update.js', { updates: updates })
        .then(repaint)
        .then(function (ok) { if (!ok) window.location.reload(); });
    }).catch(function (err) {
      console.error('[cart-addons] could not clear stranded add-ons', err);
    }).then(function () { cleaning = false; });
  }

  document.addEventListener('change', function (event) {
    var input = event.target.closest && event.target.closest('[data-cart-addon-toggle]');
    if (!input) return;

    if (busy) { input.checked = !input.checked; return; }
    busy = true;
    input.disabled = true;

    var variantId = input.dataset.variantId;
    var wanted = input.checked;

    /* /cart/update.js SETS an absolute quantity, so it is idempotent both ways:
       ticking twice cannot stack to qty 2, and unticking something already gone
       is a no-op. add.js increments (a stale tab double-adds) and change.js
       rejects a numeric id with 400. Keys are variant ids as strings. */
    var updates = {};
    updates[variantId] = wanted ? 1 : 0;

    postJSON('/cart/update.js', { updates: updates })
      .then(repaint)
      .then(function (ok) { if (!ok) window.location.reload(); })
      .catch(function (err) {
        console.error('[cart-addons] toggle failed', err);
        input.checked = !wanted;
        input.disabled = false;
      })
      .then(function () { busy = false; });
  });

  /* Only touches the network when Liquid already determined the cart is stranded,
     so a normal page load costs nothing extra. */
  if (CFG.stranded) clearStranded();

  /* Load order on this store, verified in headless Chrome 2026-10-05: the event
     bus (MinimogEvents) already exists before the shopper does anything, but the
     cart/drawer code (MinimogTheme.Cart, in app.min.js) is lazy —
     snippets/lazy-scripts.liquid only loads it on the first `scroll` or
     `touchstart`, not on load and not on click. The bus is normally ready at once;
     polling with no cap just guarantees the listener attaches whatever the order.
     The drawer, where items get removed, comes from the lazy bundle, so this is
     always in place before it matters. */
  (function subscribeWhenReady() {
    var ev = window.MinimogEvents;
    if (ev && typeof ev.subscribe === 'function') {
      ev.subscribe('ON_CART_UPDATE', function (cart) { clearStranded(cart); });
      return;
    }
    setTimeout(subscribeWhenReady, 500);
  })();
})();
